import {defaultFetch, httpMethod} from "@/scripts/Common/api";
import type {ApiResponse} from "@/scripts/Common/api";
import {getToken} from "@/scripts/Common";
import type {CardUser} from "@/components/cardUsers/scripts/types";

const fetchCardUsers = async (): Promise<ApiResponse<CardUser[]>> => await defaultFetch({
    apiName: 'cardUser',
    bearer: getToken()
});


const createOrUpdateCardUser = async (user: CardUser, method: httpMethod.PUT | httpMethod.POST)
    : Promise<ApiResponse<number>> => await defaultFetch({
    apiName: 'cardUser',
    options: {
        method,
    },
    body: JSON.stringify(user),
    bearer: getToken()
});


const deleteCardUser = async (userId: number): Promise<{ error: any }> => {
    const {
        error,
    } = await defaultFetch({
        apiName: 'cardUser',
        options: {
            method: httpMethod.DELETE,
            query: {
                userId: userId
            }
        },
        bearer: getToken()
    });

    return {
        error,
    };
}

export {
    fetchCardUsers,
    deleteCardUser,
    createOrUpdateCardUser
}
